function defaultClasses(properties = {}) {
    const { loading, valid, enabled, selected, readOnly } = properties;
    return {
        'is-disabled': enabled === false,
        'is-invalid': valid === false,
        'is-loading': loading === true,
        'is-read-only': readOnly === true,
        'is-selected': selected === true,
    };
}
export default defaultClasses;
//# sourceMappingURL=default-classes.js.map